import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { CheckSquare, X, MoreHorizontal, Edit } from "lucide-react";
import { useTranslation } from "react-i18next";

interface MatchMultiSelectActionsProps {
  selectedCount: number;
  isMultiSelectMode: boolean;
  onToggleMultiSelect: () => void;
  onMassUpdate: () => void;
  selectAll?: () => void;
}

export const MatchMultiSelectActions = ({
  selectedCount,
  isMultiSelectMode,
  onToggleMultiSelect,
  onMassUpdate,
  selectAll,
}: MatchMultiSelectActionsProps) => {
  const { t } = useTranslation();

  if (!isMultiSelectMode) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={onToggleMultiSelect}
        className="flex items-center gap-2"
      >
        <CheckSquare className="h-4 w-4" />
        {t("common.selectMultiple")}
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onToggleMultiSelect}
        className="flex items-center gap-2"
      >
        <X className="h-4 w-4" />
        {t("common.cancel")}
      </Button>
      {selectAll && (
        <Button
          variant="outline"
          size="sm"
          onClick={selectAll}
          className="flex items-center gap-2"
        >
          <CheckSquare className="h-4 w-4" />
          {t("common.selectAll")}
        </Button>
      )}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="flex items-center gap-2"
            disabled={selectedCount === 0}
          >
            <MoreHorizontal className="h-4 w-4" />
            {t("common.actions")}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onClick={onMassUpdate}
            disabled={selectedCount === 0}
            className="flex items-center gap-2"
          >
            <Edit className="h-4 w-4" />
            Mass Update ({selectedCount})
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
